import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
const baseURL = process.env.REACT_APP_API_JOBS;

export default function Add({ increment, counter, moamad }) {
  const [newExpr, setNewExpr] = useState({
    address: "",
    start_date: "",
    end_date: "",
    job: "",
    last_salary: "",
    end_reason: "",
    moamad: moamad.id,
  });
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();

  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;

    setNewExpr((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();
    const getData = async () => {
      try {
        const response = await axiosPrivate.post(
          baseURL + "workexperience/",
          newExpr,
          {
            signal: controller.signal,
          }
        );
        isMounted && increment();
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    getData();
  };
  // render
  return (
    <div>
      <center>
        <div className="card text-dark bg-light container p-3  border">
          <div className="card-header">
            <h3>
              ניסיון תעסוקתי של המועמד: {moamad.f_name}{" "}
              {moamad.father_name ? moamad.father_name + " " : ""}{" "}
              {moamad.l_name}
            </h3>
          </div>
          <div className="card-body">
            <Row>
              <Col>
                <form onSubmit={handleSubmit} className="mbsc-form-group">
                  <div className="form-group">
                    <label htmlFor="address">שם וכתובת מקום העבודה</label>
                    <input
                      type="text"
                      name="address"
                      className="form-control"
                      id="address"
                      value={newExpr.address}
                      placeholder=""
                      onChange={handleChange}
                    />
                  </div>
                  <br></br>
                  <Row>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="start_date">תחילת עבודה</label>
                        <input
                          type="date"
                          name="start_date"
                          className="form-control"
                          id="start_date"
                          value={newExpr.start_date}
                          placeholder=""
                          onChange={handleChange}
                        />
                      </div>
                    </Col>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="subject">סיום עבודה</label>
                        <input
                          type="date"
                          name="end_date"
                          className="form-control"
                          id="end_date"
                          value={newExpr.end_date}
                          placeholder=""
                          onChange={handleChange}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <br></br>
                  </Row>
                  <Row>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="job">תפקיד</label>
                        <input
                          type="text"
                          name="job"
                          className="form-control"
                          id="job"
                          value={newExpr.job}
                          onChange={handleChange}
                        />
                      </div>
                    </Col>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="last_salary">
                          השכר שהתקבל לאחרונה/דרגה
                        </label>
                        <input
                          type="text"
                          name="last_salary"
                          className="form-control"
                          id="last_salary"
                          value={newExpr.last_salary}
                          onChange={handleChange}
                        />
                      </div>
                    </Col>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="end_reason">סיבת הפסקת העבודה</label>
                        <input
                          type="text"
                          name="end_reason"
                          className="form-control"
                          id="end_reason"
                          value={newExpr.end_reason}
                          onChange={handleChange}
                        />
                      </div>
                    </Col>
                  </Row>

                  <br />
                  <button type="submit" className="btn btn-primary">
                    הוסף
                  </button>
                </form>
              </Col>
            </Row>
          </div>
        </div>
      </center>
    </div>
  );
}
